import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.js%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-ExtraLight.ttf%22,%22weight%22:%22200%22},{%22path%22:%22../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-Light.ttf%22,%22weight%22:%22300%22},{%22path%22:%22../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-Regular.ttf%22,%22weight%22:%22400%22},{%22path%22:%22../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-Medium.ttf%22,%22weight%22:%22500%22},{%22path%22:%22../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-SemiBold.ttf%22,%22weight%22:%22600%22},{%22path%22:%22../../../../public/fonts/brand/ellis-brigham/Oswald/static/Oswald-Bold.ttf%22,%22weight%22:%22700%22}],%22variable%22:%22--brand-font%22}],%22variableName%22:%22oswaldFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'oswaldFont', 'oswaldFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
